import { Log, apiRequest } from '@ext/utils'; import { Paginacion } from '@ext/env';
export * from './Variaciones.types';
import { IVariaciones } from './Variaciones.lib';

export class Variaciones extends IVariaciones {

    public static async create( id: number ): Promise<Variaciones> {
        let o = new Variaciones();
        o.Variacion = id;
        if ( await o.find() ) {
            return o;
        }
        return null;
    }
    protected Route: string = '/mercadolibre/publicaciones/variaciones';
    protected async find(): Promise<boolean> {

        this.Existe = false;
        let request = new apiRequest();
        request.path = `${this.Route}/${this.Variacion}`;
        if ( await request.get() ) {
            this.Json = request.data;
            this.set();
        }
        return this.Existe;
    }

    public static async find( params: any ): Promise<{ Paginacion: Paginacion, Items: Array<Variaciones>; Error?: boolean; }> {

        let a: Array<Variaciones> = [];
        let paginacion: Paginacion = new Paginacion();
        let request = new apiRequest( `/mercadolibre/publicaciones/variaciones` );
        request.params = params;
        if ( await request.get() ) {
            if ( request.data.response ) {
                paginacion = new Paginacion( request.data.response );
            }
            if ( request.data.results ) {
                for ( let i of request.data.results ) {
                    let p = new Variaciones( i );
                    a.push( p );
                }

            }
        }
        return { Paginacion: paginacion, Items: a, Error: request.error };
    }
}